import { render, staticRenderFns } from "./ProductImageField.vue?vue&type=template&id=c2c8b0be&scoped=true"
import script from "./ProductImageField.vue?vue&type=script&lang=js"
export * from "./ProductImageField.vue?vue&type=script&lang=js"
import style0 from "./ProductImageField.vue?vue&type=style&index=0&id=c2c8b0be&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c2c8b0be",
  null
  
)

export default component.exports